import type { SankeyChartNodesProps } from '../types/sankey-props.js';

/**
 * Slot for configuring the nodes within a `SankeyChart` (width, alignment, and
 * the exit-bar remainder). Rendered as a no-op; its props are collected into
 * the node config context.
 * @internal
 */
export const Nodes = (props: SankeyChartNodesProps) => null;

Nodes.displayName = 'SankeyChart.Nodes';
